module.exports = __webpack_public_path__ + "img/svg/competition-card.5aeed0b884f522de4eb31ba6b26fc6a8.svg";